var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrameGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 48,
    viewBox: "0 0 8 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 48,
    rx: 4,
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameGray);
export default __webpack_public_path__ + "static/media/frame_gray.149e2437858c2b631fb51a8012343b59.svg";
export { ForwardRef as ReactComponent };